// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const hostUrl = 'https://fleet-alicedx-services-a6bzd6f8a2ezembt.centralus-01.azurewebsites.net'
export const environment = {
  production: false,
  authServiceURL: 'https://alice-dx-services-demo.azurewebsites.net/auth/login',

  getUserUrl: 'https://alice-dx-services-demo.azurewebsites.net/auth/getUser',

  backdropLogo:
    'https://cpodsdev.blob.core.windows.net/cpods-dev-storage/cpods-ui/BGCPodsLogin.jpg',
  rightLoginLogo:
    'https://cpodsdev.blob.core.windows.net/cpods-dev-storage/cpods-ui/hitachiWhite.png',
  loginCpodLogo:
    'https://cpodsdev.blob.core.windows.net/cpods-dev-storage/cpods-ui/cpodLogoNew.png',
  getFilterData: 'https://cpods-vpi-services.azurewebsites.net/vehiclePartsInspection/getFilteredData',
  
  getFleetUrl: `${hostUrl}/fleets/getAll`,
  getRepairShops: `${hostUrl}/fleets/getRepairShops`, 
  getEventsUrl: `${hostUrl}/events/getAll`,
  getAggregatedresult: `${hostUrl}/fleets/getAggregatedData`,
  filterMenu: `${hostUrl}/filters/getMenu`,
  getFilteredData: `${hostUrl}/filters/getFilterData`,
  geteventHistoryDataURL: `${hostUrl}/events/eventHistory`,
  getFleetDetailsDataURL: `${hostUrl}/fleets/getDetails`,
  saveFilterURL: `${hostUrl}/filters/save`,
  getMyFilters: `${hostUrl}/filters/getSavedFilters`,
  updateFilter: `${hostUrl}/filters/update`,
  deleteFilter: `${hostUrl}/filters/delete`,
  createWorkOrder: `${hostUrl}/workOrder/create`,
  generateRecommendations : `${hostUrl}/workOrder/repairRecomm`,
  completeWorkOrder:`${hostUrl}/workOrder/complete`,
  saveresolutionComment : `${hostUrl}/workOrder/repairRecommSave`, 
  technicianList : 'https://alice-dx-services-demo.azurewebsites.net/myTeam/getTechnicians/',
  logoDescription: 'Hitachi Connected Vehicle Analytics',
  leftLoginLogo: '',
  leftLoginLogoAlt: '',
  landingURL: 'https://cpod-landingpage-dot-cephalopods-hal.appspot.com',

  mapsApiKey: 'AIzaSyDGPX8yQ6OUVeBhdgqh8GPZ0WaKQAakvAI',
  legendsIconsBaseUrl: '/assets/images/map-legends/',
  markerIconsBaseUrl: '/assets/images/map-markers/',
  mapHeight: '76vh',
  mapHeightFS: '96vh',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
